// src/components/strumenti/InteressiMora.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function InteressiMora() {
  const [capitale, setCapitale] = useState("");
  const [tasso, setTasso] = useState("");
  const [giorni, setGiorni] = useState("");

  const C = leggiNumero(capitale)||0;
  const t = leggiNumero(tasso)||0;
  const g = leggiNumero(giorni)||0;

  const interessi = (C * (t/100) * g) / 365;
  const totale = C + interessi;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Importo (€)</label>
          <input value={capitale} onChange={e=>setCapitale(e.target.value)} style={inp} placeholder="Es. 5000"/>
        </div>
        <div>
          <label style={lbl}>Tasso annuo (%)</label>
          <input value={tasso} onChange={e=>setTasso(e.target.value)} style={inp} placeholder="Es. 8"/>
        </div>
        <div>
          <label style={lbl}>Giorni di ritardo</label>
          <input value={giorni} onChange={e=>setGiorni(e.target.value)} style={inp} placeholder="Es. 30"/>
        </div>
      </div>

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around" }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Interessi maturati</div>
            <div style={{ fontSize:20, fontWeight:700, color:"#374151" }}>{C>0 ? interessi.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Totale dovuto</div>
            <div style={{ fontSize:22, fontWeight:800, color:"#059669" }}>{C>0 ? totale.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Calcolo a interesse semplice — inserisci tu il tasso pattuito o quello di riferimento applicabile al caso.
      </div>

      <button onClick={()=>{setCapitale("");setTasso("");setGiorni("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
